$mol_bigint_field $mol_bar
	step 1n
	boost 10n
	value_min null bigint
	value_max null bigint
	value? 0n
	enabled? true
	plugins /
		<= Hotkey $mol_hotkey
			key *
				down? <=> decrement? null
				up? <=> increment? null
				pageDown? <=> decrement_boost? null
				pageUp? <=> increment_boost? null
	sub /
		<= String $mol_string
			type \text
			keyboard \decimal
			value? <=> value_string? \
			hint <= hint \ 
			enabled <= string_enabled <= enabled
			submit? <=> submit? null
			selection? <=> selection? /number
		<= Decrement $mol_button_minor
			click? <=> decrement? null
			enabled <= decrement_enabled <= enabled
			sub /
				<= Decrement_icon $mol_icon_menu_down_outline
		<= Increment $mol_button_minor
			click? <=> increment? null
			enabled <= increment_enabled <= enabled
			sub /
				<= Increment_icon $mol_icon_menu_up_outline
